import { Box, Typography } from '@mui/material'
import { ReactFitty } from "react-fitty";
import React from 'react'
import codeImg from '../../assets/img/homePage/code.jpg'

const Home = () => {
  return (
    <Box
      sx={{
        width: '100%',
        height: '100dvh',
        padding: '100px 100px 0 100px',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        '@media screen and (max-width: 600px)': {
          padding: '100px 10px'
        }
      }} >
      <Typography
        sx={{ textAlign: 'center', position: 'relative', zIndex: 1, lineHeight: 0.8 }}
        component={ReactFitty}
        color='primary'
      >
        PORTFOLIO
      </Typography>
      <Typography
        sx={{
          fontFamily: "Great Vibes",
          textAlign: 'center',
          position: 'relative',
          zIndex: 2,
          width: '50%',
          marginTop: "-220px",
          color: '#fd4002',
          fontSize: '9rem',
          '@media screen and (max-width: 600px)': {
            marginTop: "-110px",
            textAlign: 'right',
            fontSize: '4rem',
            width: '100%',
            padding: "0 40px"
          }
        }}>
        Logical
      </Typography>
      <Box sx={{
        marginTop: '-40px',
        '@media screen and (max-width: 600px)': {
          marginTop: "0px",
        }
      }}>
        <img src={codeImg} alt="codeImg" width={"100%"} height={"100%"} />
      </Box>
      <Typography
        sx={{
          fontFamily: "Great Vibes",
          fontSize: '1.8rem',
          position: 'absolute',
          bottom: "20px",
          zIndex: 1,
          width: '100%',
          padding: '0 110px 0 100px',
          textAlign: 'right',
          '@media screen and (max-width: 600px)': {
            textAlign: 'center',
            fontSize: '1.5rem',
          }
        }}>
        Created by - Ruslan
      </Typography>
    </Box>
  );
};

export default Home;